declare global {interface Window{dataLayer:Record<string,any>[]}};
interface TrackEventParams{[key:string]:string|number|boolean;}

export const trackEvent=(eventName:string,params:TrackEventParams={})=>{
        window.dataLayer=window.dataLayer||[];
        window.dataLayer.push({event:eventName,...params});
        }
